import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/layouts/checkout.vue").then(m => m.default || m)),
  clean: defineAsyncComponent(() => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/layouts/clean.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/layouts/default.vue").then(m => m.default || m))
}